import { getStore } from 'core_main/store';
import { InitializePubNubParameters } from 'core_main/pubnub/types';

import { PUBNUB_SUBSCRIBE_OPERATION } from '../pubnub/constants';

export const importAndInitializePubNub = (
  params?: InitializePubNubParameters,
) => {
  return import(/* webpackChunkName: "pubnub" */ '../pubnub').then((pubnub) => {
    if (!params) return pubnub;

    const { customerId, orgId, channels, initCallback } = params;
    const store = getStore();

    if (!store.isPubNubConnected) {
      return pubnub.initializePubNub({
        customerId,
        orgId,
        initCallback,
        channels,
      });
    }

    if (channels) {
      if (typeof initCallback === 'function') {
        const listenerParams = {
          status: (statusEvent) => {
            const { operation, affectedChannels } = statusEvent;
            if (operation === PUBNUB_SUBSCRIBE_OPERATION) {
              const includedChannels = channels.filter((channel) =>
                affectedChannels?.includes(channel),
              );
              if (includedChannels.length === channels.length) {
                initCallback();
                pubnub.removeListener(listenerParams);
              }
            }
          },
        };

        pubnub.addListener(listenerParams);
      }

      pubnub.subscribe({ channels });
    }

    return pubnub;
  });
};
